import { api } from './api.js';

export const globalConfigAPI = {
  get: async () => {
    const response = await api.get('/globalConfig/get');
    return response.data;
  },

  save: async (data) => {
    const response = await api.post('/globalConfig/save', data);
    return response.data;
  }
};

